import { render, staticRenderFns } from "./whatnowContentItem.vue?vue&type=template&id=212c4c28&scoped=true"
import script from "./whatnowContentItem.vue?vue&type=script&lang=js"
export * from "./whatnowContentItem.vue?vue&type=script&lang=js"
import style0 from "./whatnowContentItem.vue?vue&type=style&index=0&id=212c4c28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212c4c28",
  null
  
)

export default component.exports